import styled from "@emotion/styled"
import { breakpoints, dimensions, theme } from "../../../utils/styles"

export const Section = styled.section`
  background: ${({ theme }) => theme.black};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 32px;

  @media (max-width: ${breakpoints.l}px) {
    padding: 48px 24px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${dimensions.contentWidth};
`

export const Eyebrow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.primary};

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.primary};
  }
`

export const Container = styled.div`
  color: ${({ theme }) => theme.white};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 64px 0;
  gap: 32px 96px;
  max-width: ${dimensions.contentWidth};

  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 48px 0;
  }
`

export const Link = styled.a`
  color: ${({ theme }) => theme.white};
  text-decoration: none;
`

export const Date = styled.p`
  font-size: 14px;
  margin-bottom: 8px;
`

export const Title = styled.h3`
  font-size: 24px;
  margin: 0;
`

export const NextButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

export const NextButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  background: ${theme.primary};
  color: ${theme.black};
  font-weight: 700;
  font-size: 15px;
  font-family: Nunito, sans-serif;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  svg {
    width: 16px;
    height: 16px;
    transition: transform 0.25s ease;
  }

  &:hover {
    transform: translateY(3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  }

  &:hover svg {
    transform: translateY(2px);
  }
`
